import { TooltipPosition } from "@angular/material/tooltip";
import { ButtonData } from "src/app/features/shared/controls/models/button-data";
import { isEmptyObject } from "src/app/infrastructure/functions/is-empty-object.function";
import { IButtonData } from "../../controls/models/_base-button";

enum ListButtonData {
    hide = 'hide',
    disabled = 'disabled',
    tooltip = 'tooltip',
    tooltipPosition = 'tooltipPosition',
}

export const listButtonData = {...ListButtonData} as const;

export interface IListButtonData extends IButtonData {
    [listButtonData.hide]?: boolean;
    [listButtonData.disabled]?: boolean;
    [listButtonData.tooltip]?: string;
    [listButtonData.tooltipPosition]?: TooltipPosition;
}

export abstract class _BaseListButtonData
    extends ButtonData
    implements IListButtonData
{
    [listButtonData.hide] = true;
    [listButtonData.disabled] = true;
    [listButtonData.tooltip]: string = '';
    [listButtonData.tooltipPosition]: TooltipPosition = 'above';

    protected constructor(buttonData?: IListButtonData | null) {
        super(buttonData ?? null);
        if (!buttonData || isEmptyObject(buttonData)) return;

        this[listButtonData.hide] = buttonData[listButtonData.hide] ?? this[listButtonData.hide];
        this[listButtonData.disabled] = buttonData[listButtonData.disabled] ?? this[listButtonData.disabled];
        this[listButtonData.tooltip] = buttonData[listButtonData.tooltip] ?? this[listButtonData.tooltip];
        this[listButtonData.tooltipPosition] = buttonData[listButtonData.tooltipPosition] ?? this[listButtonData.tooltipPosition];
    }
}
